import { ComponentType, Icon, IconName } from '@gcl/react-core';
import * as React from 'react';
import { Note } from './Note';

export interface INoteItem<C extends React.ReactElement<typeof Icon>> {
  className?: string;
  componentType?: ComponentType;
  prefixIcon?: C | IconName;
  note: string | React.ReactElement;
}

export interface INoteListProps<C extends React.ReactElement<typeof Icon>> {
  items: INoteItem<C>[];
  className?: string;
}

export const NoteList = <C extends React.ReactElement>({ items, className = '' }: INoteListProps<C>) => {
  return (
    <div className={`gcl-note-list-container ${className}`}>
      {items.map((item, index) => {
        return (
          <Note
            key={`${index.toString()}_${item.note}`}
            className={`gcl-fb-md ${item.className || ''} ${index !== 0 ? 'gcl-mt-xs' : ''}`}
            componentType={item.componentType}
            prefixIcon={
              item.prefixIcon && typeof item.prefixIcon === 'string' ? (
                <Icon iconName={item.prefixIcon as IconName} />
              ) : (
                item.prefixIcon
              )
            }
          >
            {item.note}
          </Note>
        );
      })}
    </div>
  );
};
